import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetDetailTransaction  {
    _originalTypeClassName = "zERP.BO.BudgetDetailTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetDetailTransaction.translate = translateService;
}
this.BudgetDetail = new Domain.BudgetDetail();
this.Id = null;
this.Amount = null;
this.Date = null;
this.From = null;
this.To = null;
this.DocumentType = null;
this.DocumentId = null;
this.DetailDocumentId = null;
this.Description = null;
this.Username = null;
this.IncomeApprovedAmount = null;
this.IncomeReceiptApprovedAmount = null;
this.ReceivedAmount = null;
this.IncomeSettledAmount = null;
this.Entity = null;
this.Type = null;
this.InitialApprovedAmount = null;
this.AdjustmentsAmount = null;
this.TotalBudgetAmount = null;
this.ReservedAmount = null;
this.RemainingBudgetAmount = null;
this.InvoicedAmount = null;
this.RemainingReservedAmount = null;
this.PaymentOrderedAmount = null;
this.RemainingInvoicedAmount = null;
this.PaidAmount = null;
this.RemainingPaymentOrderdAmount = null;
this.IsExpense = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Amount:any;
Date:any;
From:any;
To:any;
DocumentType:any;
DocumentId:any;
DetailDocumentId:any;
Description:any;
Username:any;
IncomeApprovedAmount:any;
IncomeReceiptApprovedAmount:any;
ReceivedAmount:any;
IncomeSettledAmount:any;
Entity:any;
Type:any;
InitialApprovedAmount:any;
AdjustmentsAmount:any;
TotalBudgetAmount:any;
ReservedAmount:any;
RemainingBudgetAmount:any;
InvoicedAmount:any;
RemainingReservedAmount:any;
PaymentOrderedAmount:any;
RemainingInvoicedAmount:any;
PaidAmount:any;
RemainingPaymentOrderdAmount:any;
IsExpense:any;
BudgetDetail:any;
static setBudgetDetail = ($this, value) => {
var oldValue = $this.BudgetDetail;
$this.BudgetDetail = value;
if (value != null) {
}
}

static GetRemainingBudgetAmount($this: any): any{let totalBudgetAmount = Domain.BudgetDetailTransaction.GetTotalBudgetAmount($this);
if (CLMS.Framework.Number.Equal(() => totalBudgetAmount, () => null)) {totalBudgetAmount = 0;}
if ($this?.IsExpense) {let reservedAmount = (CLMS.Framework.Number.NotEqual(() => $this.ReservedAmount, () => null) ? $this?.ReservedAmount : 0);return Joove.Common.safeNumber(totalBudgetAmount) - Joove.Common.safeNumber(reservedAmount);}
let receivedAmount = (CLMS.Framework.Number.NotEqual(() => $this.ReceivedAmount, () => null) ? $this?.ReceivedAmount : 0);
return Joove.Common.safeNumber(totalBudgetAmount) - Joove.Common.safeNumber(receivedAmount);
}
static GetRemainingInvoicedAmount($this: any): any{let invoicedAmount = (CLMS.Framework.Number.NotEqual(() => $this.InvoicedAmount, () => null) ? $this?.InvoicedAmount : 0);
let paymentOrderedAmount = (CLMS.Framework.Number.NotEqual(() => $this.PaymentOrderedAmount, () => null) ? $this?.PaymentOrderedAmount : 0);
return Joove.Common.safeNumber(invoicedAmount) - Joove.Common.safeNumber(paymentOrderedAmount);
}
static GetRemainingPaymentOrderdAmount($this: any): any{let paymentOrderedAmount = (CLMS.Framework.Number.NotEqual(() => $this.PaymentOrderedAmount, () => null) ? $this?.PaymentOrderedAmount : 0);
let paidAmount = (CLMS.Framework.Number.NotEqual(() => $this.PaidAmount, () => null) ? $this?.PaidAmount : 0);
return Joove.Common.safeNumber(paymentOrderedAmount) - Joove.Common.safeNumber(paidAmount);
}
static GetRemainingReservedAmount($this: any): any{let reservedAmount = (CLMS.Framework.Number.NotEqual(() => $this.ReservedAmount, () => null) ? $this?.ReservedAmount : 0);
let invoicedAmount = (CLMS.Framework.Number.NotEqual(() => $this.InvoicedAmount, () => null) ? $this?.InvoicedAmount : 0);
return Joove.Common.safeNumber(reservedAmount) - Joove.Common.safeNumber(invoicedAmount);
}
static GetTotalBudgetAmount($this: any): any{let initialApprovedAmount = (CLMS.Framework.Number.NotEqual(() => $this.InitialApprovedAmount, () => null) ? $this?.InitialApprovedAmount : 0);
let adjustmentsAmount = (CLMS.Framework.Number.NotEqual(() => $this.AdjustmentsAmount, () => null) ? $this?.AdjustmentsAmount : 0);
return Joove.Common.safeNumber(initialApprovedAmount) + Joove.Common.safeNumber(adjustmentsAmount);
}
static ToBudgetDetailTransactionDTO($this: any, reservedRemainingAmount: any,balanceToReserveAmount: any): any{let transactionDtos = [];
let progressivelyDto = new Domain.BudgetDetailTransactionDTO();
progressivelyDto.ReservedRemaining = reservedRemainingAmount;
progressivelyDto.BalanceToReserve = balanceToReserveAmount;
let dto = new Domain.BudgetDetailTransactionDTO();
dto.Id = $this?.Id;
dto.Date = $this?.Date;
dto.Entity = $this?.Entity;
dto.Type = $this?.Type;
dto.Counterpart = "";
dto.ReservedRemaining = reservedRemainingAmount;
dto.BalanceToReserve = balanceToReserveAmount;
switch ($this?.Entity) {case Domain.BudgetEntity.Budget:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Approval) {dto.Approval = $this?.Amount;dto.BalanceToReserve = Joove.Common.safeNumber(progressivelyDto?.BalanceToReserve) + Joove.Common.safeNumber($this?.Amount);progressivelyDto.BalanceToReserve = Joove.Common.safeNumber(progressivelyDto?.BalanceToReserve) + Joove.Common.safeNumber($this?.Amount);}break;}
case Domain.BudgetEntity.BudgetAdjustment:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Adjustment) {dto.Adjustment = $this?.Amount;dto.BalanceToReserve = Joove.Common.safeNumber(progressivelyDto?.BalanceToReserve) + Joove.Common.safeNumber($this?.Amount);progressivelyDto.BalanceToReserve = Joove.Common.safeNumber(progressivelyDto?.BalanceToReserve) + Joove.Common.safeNumber($this?.Amount);}break;}
case Domain.BudgetEntity.SpendingRequest:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Request) {dto.Reserved = $this?.Amount;dto.ReservedRemaining = Joove.Common.safeNumber(progressivelyDto?.ReservedRemaining) + Joove.Common.safeNumber($this?.Amount);dto.BalanceToReserve = Joove.Common.safeNumber(progressivelyDto?.BalanceToReserve) - Joove.Common.safeNumber($this?.Amount);progressivelyDto.ReservedRemaining = Joove.Common.safeNumber(progressivelyDto?.ReservedRemaining) + Joove.Common.safeNumber($this?.Amount);progressivelyDto.BalanceToReserve = Joove.Common.safeNumber(progressivelyDto?.BalanceToReserve) - Joove.Common.safeNumber($this?.Amount);}break;}
case Domain.BudgetEntity.Invoice:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Invoicing) {dto.Invoiced = $this?.Amount;dto.ReservedRemaining = Joove.Common.safeNumber(progressivelyDto?.ReservedRemaining) - Joove.Common.safeNumber($this?.Amount);progressivelyDto.ReservedRemaining = Joove.Common.safeNumber(progressivelyDto?.ReservedRemaining) - Joove.Common.safeNumber($this?.Amount);}else if ($this?.Type == Domain.BudgetDetailTransactionType.Cancelation) {dto.Invoiced = Joove.Common.safeNumber(0) - Joove.Common.safeNumber($this?.Amount);dto.ReservedRemaining = Joove.Common.safeNumber(progressivelyDto?.ReservedRemaining) + Joove.Common.safeNumber($this?.Amount);progressivelyDto.ReservedRemaining = Joove.Common.safeNumber(progressivelyDto?.ReservedRemaining) + Joove.Common.safeNumber($this?.Amount);}break;}
case Domain.BudgetEntity.PaymentOrder:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Order) {dto.OrderToBePaid = $this?.Amount;}else if ($this?.Type == Domain.BudgetDetailTransactionType.Cancelation) {dto.OrderToBePaid = Joove.Common.safeNumber(0) - Joove.Common.safeNumber($this?.Amount);}break;}
case Domain.BudgetEntity.Payment:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Payment) {dto.Paid = $this?.Amount;}else if ($this?.Type == Domain.BudgetDetailTransactionType.Cancelation) {dto.Paid = Joove.Common.safeNumber(0) - Joove.Common.safeNumber($this?.Amount);}break;}
case Domain.BudgetEntity.IncomeReceipt:
{
if ($this?.Type == Domain.BudgetDetailTransactionType.Issue) {dto.Invoiced = $this?.Amount;}else if ($this?.Type == Domain.BudgetDetailTransactionType.Payment) {dto.Received = $this?.Amount;}break;}
}
transactionDtos?.add(dto);
transactionDtos?.add(progressivelyDto);
return transactionDtos;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}